<template>
  <v-app id="app" v-if="loadingAuth">
    <router-view />
  </v-app>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { mustBeGuestAuthenticate } from '@/shared/token'

export default {
  computed: {
    ...mapState('auth', ['isAuthenticated']),
    ...mapState('cart', ['cart'])
  },
  data: function () {
    return {
      loadingAuth: false
    }
  },
  methods: {
    ...mapMutations('cart', ['setCart']),
    ...mapActions('websocket', ['createConnection']),
    ...mapActions('auth', ['signInGuest'])
  },
  watch: {
    isAuthenticated: function (value) {
      if (value) {
        this.createConnection()
      }
    }
  },
  async created () {
    if (this.isAuthenticated) {
      this.loadingAuth = true
      this.createConnection()
      return
    }

    if (mustBeGuestAuthenticate()) {
      await this.signInGuest()
    }

    this.loadingAuth = true
  },
  mounted () {
    window.addEventListener('storage', e => {
      if (e.key !== 'vuex') {
        return
      }

      const value = JSON.parse(e.newValue)
      if (value.cart.cart === this.cart) {
        return
      }

      this.setCart(value.cart.cart)
    })
  }
}
</script>

<style>
#app {
  /*font-family: "Montserrat", sans-serif;*/
  font-family: Proxima Nova, -apple-system,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 16px;
}

@keyframes autofill {
    0%,100% {
        color: inherit;
        background: transparent;
    }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  animation-delay: 1s;
  animation-name: autofill;
  animation-fill-mode: both;
}

.first-capital-letter::first-letter{
  text-transform: uppercase;
}

.section-title{
  font-size: 1em !important;
  font-weight: 500;
  color: #333333;
}

.card-border-top{
  border-top: 1px solid;
  border-color: rgba(0, 0, 0, 0.12) !important;
}

.card-border-left{
  border-left: 1px solid;
  border-color: rgba(0, 0, 0, 0.12) !important;
}

.card-border-right{
  border-right: 1px solid;
  border-color: rgba(0, 0, 0, 0.12) !important;
}

.card-border-bottom{
  border-bottom: 1px solid;
  border-color: rgba(0, 0, 0, 0.12) !important;
}

.payment-pending {
  font-weight: 700;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.55) !important;
}
.payment-in_progress {
  font-weight: 700;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.55) !important;
}
.payment-success {
  font-weight: 700;
  font-size: 13px;
  color: #388E3CFF !important;
}
.payment-failure {
  font-weight: 700;
  font-size: 13px;
  color: #FA113DFF !important;
}
.payment-expired {
  font-weight: 700;
  font-size: 13px;
  color: #FA113DFF !important;
}
.payment-cancelled {
  font-weight: 700;
  font-size: 13px;
  color: #FA113DFF !important;
}
.payment-pending_delivery {
  font-weight: 700;
  font-size: 13px;
  color: #3483FAFF !important;
}
.payment-refund {
  font-weight: 700;
  font-size: 13px;
  color: #FB8C00FF !important;
}
</style>
